import { h, render } from 'preact';
import PopularPodcasts from '~/components/PopularPodcasts';

function search() {
  const popularPodcastsNode = document.querySelector('#popularpodcasts');
  if (popularPodcastsNode) {
    render(
      h(PopularPodcasts, {
        title: 'Populärt på Poddtoppen just nu',
        action: '/populara',
        itemCount: 7,
      }),
      popularPodcastsNode,
    );
  }
}

search();
